module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/499a035b3b3b283ca4257fd26c725491.png";